import { render } from "./selected-filters.vue?vue&type=template&id=0f0eabe3"
import script from "./selected-filters.vue?vue&type=script&lang=js"
export * from "./selected-filters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__